import Badge from "app/components/Badge";
import type { Lesson } from "app/services/types";
import { fmtTime, lessonPhase } from "app/utils/time";

export default function LessonRow({ lesson, studentNames, onClick }: { lesson: Lesson; studentNames: string[]; onClick: () => void }) {
  const phase = lessonPhase(lesson.start, lesson.end);
  const colour = lesson.subjectColour || "#4c54a0";
  return (
    <button type="button" className={`ct-lesson w-100 text-start ${lesson.cancelled ? "cancelled" : ""}`} onClick={onClick} aria-label={`${lesson.subject} lesson at ${fmtTime(lesson.start)}`}>
      <div className="bar" style={{ background: lesson.cancelled ? "#d2d2d5" : colour }} />
      <div className="time">
        {fmtTime(lesson.start)}
        <small>{fmtTime(lesson.end)}</small>
      </div>
      <div className="body">
        <div className="title">{lesson.year ? `${lesson.year} ` : ""}{lesson.subject}</div>
        <div className="meta">
          {lesson.classId}{lesson.teacher ? ` · ${lesson.teacher}` : ""}{studentNames.length ? ` · ${studentNames.join(", ")}` : ""}
        </div>
        <div className="mt-2 d-flex gap-2 align-items-center flex-wrap">
          {lesson.cancelled ? <Badge status="danger" text="Cancelled" size="sm" />
            : phase === "live" ? <Badge status="success" text="Happening now" size="sm" />
            : phase === "soon" ? <Badge status="warning" text="Starting soon" size="sm" />
            : phase === "past" ? <Badge status="muted" text={lesson.status === "completed" ? "Completed" : "Finished"} size="sm" />
            : <Badge status="primary" text={lesson.classType === "private" ? "Private" : lesson.classType === "hybrid" ? "Hybrid" : "Group"} size="sm" />}
          {phase === "past" && lesson.recordingLink && <Badge status="info" text="Recording" size="sm" />}
          {lesson.hasHomework && <Badge status="muted" text="Homework" size="sm" />}
        </div>
      </div>
    </button>
  );
}
